module.exports = __webpack_public_path__ + "static/media/cycle.159b1932.gif";